<template>
    <div class="userinfo-box">
        <div class="info-box" v-if="(chetouhao && cheguahao)">
          {{welcomeTitle}},
            尊敬的{{ chetouhao }}/{{ cheguahao }} 司机(押运员)
        </div>
        <div class="info-box" v-if="showBindTip && (!chetouhao || !cheguahao)">
            <span>您尚未绑定车辆信息，请先绑定车辆信息！</span>
        </div>

<!--        <div class="bind-vehicle-box">-->
<!--            <div class="bind-vehicle-btn" @click="jumpClgl()">车辆管理</div>-->
<!--        </div>-->
        
    </div>


</template>
<script>

export default {
  created() {
    const hour = new Date().getHours();
    if (hour >= 5 && hour < 9) this.welcomeTitle= "早上好";
    if (hour >= 9 && hour < 12) this.welcomeTitle= "上午好";
    if (hour >= 12 && hour < 14) this.welcomeTitle= "中午好";
    if (hour >= 14 && hour < 18) this.welcomeTitle= "下午好";
    if (hour >= 18 || hour < 5) this.welcomeTitle= "晚上好";
  },
  data() {
    return {
      welcomeTitle: ""
    };
  },
  props: {
    chetouhao: {
      type: String,
      default: ""
    },
    cheguahao:{
        type:String,
        default:""
    },
    showBindTip: {
      type: Boolean,
      default: true
    }
  },
  methods:{
    jumpClgl()
    {
        this.$router.push({
            name: 'vehicle'
          })
    }
  }
}

</script>
<style lang="scss" scoped>
.userinfo-box{
  padding: 10rpx 0;
  border-radius: 10px;
  width: 94%;
  margin-top: 1rem;
  line-height: 1.25;
  display: flex;
  justify-content: space-between;
  align-items: center;
    .info-box{
        float: left;
        font-size: 28rpx;
        //width: 65vw;
      font-weight: bold;
    }
    .bind-vehicle-box{
      margin-right: 5px;
        .bind-vehicle-btn{
          background: #1677FF;
          border-radius: 30px;
          color: #fff;
          font-size: 28rpx;
            border:1px solid #fff;
            padding: 5px 12px;
            line-height: 1.5;
            text-align: center;
        }
    }
}
</style>